<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <div class="container">
    <h2>{{ $t("signOut.signOut") }}</h2>
    <p>{{ $t("signOut.signOutMsg") }}</p>
    <form action="/api/signout" method="post">
      <input type="hidden" id="signOutId" name="signOutId" :value="id" />
      <button-comp id="submitButton" type="submit" legacyOrange large>
        {{ $t("signOut.signOut") }}
      </button-comp>
    </form>
  </div>
</template>

<script lang="ts">
export default {
  name: 'signout-view',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  margin-top: 50px;
  max-width: 540px;
}

p {
  color: $steel;
  font-size: 14px;
}
</style>
